import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import {MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatTable, MatTableDataSource} from '@angular/material/table';
import { Cf2TableConfig, Cf2TableField } from '@core/types/cf2-table-field.type';
import { TranslocoService } from '@jsverse/transloco';

const OVERDUE_DATE = new Date();

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

import * as R from 'remeda';
import {Cf2FormattedDate} from "@shared/pipes/cf2-formatted-date.pipe";
import {Cf2MaterialModule} from "@modules/cf2-material/cf2-material.module";

@Component({
  selector: 'cf2-table',
  templateUrl: './cf2-table.component.html',
  styleUrls: ['./cf2-table.component.scss'],
  viewProviders: [MatSort],
  exportAs: 'cf2Table',
  imports: [
    Cf2FormattedDate,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    Cf2MaterialModule,
  ],
})
// eslint-disable-next-line @typescript-eslint/ban-types
export class Cf2TableComponent<T extends Object, K extends string> extends MatTableDataSource<T> {
  overdueDate = yesterday;
  @ViewChild(MatSort) matSort: MatSort;
  listColumns: [K, Cf2TableField<K>][];
  @Input() set columnConfig(cfg: Cf2TableConfig<K>) {
    this.listColumns = Array.from(cfg);
    this.columns = Array.from(cfg.keys());
  }
  @Input() sortColumn: string;
  @Output() selected = new EventEmitter<T>();
  dataSource: MatTableDataSource<T>;
  columns: string[];

  isInit = false;

  @Input() set dataSub(data: T[]) {
    if (!data) return;
    this.dataSource = new MatTableDataSource(R.sortBy(data, (itm) => itm[this.sortColumn]));
    this.matSort.start = 'asc';
    this.matSort.active = this.sortColumn;
    this.matSort.disableClear = true;

    this.dataSource.sort = this.matSort;
    this.isInit = true;
  }

  constructor(private service: TranslocoService) {
    super();
  }

  ngOnInit(): void { }
}
